import axios from 'axios'; 
import { isNullOrEmpty } from '../helpers/LanguageHelpers';

const baseUrl = process.env.REACT_APP_BEACON || 'https://localhost:8443/api';
const accessControl = process.env.REACT_APP_ACCESS_CONTROL || '*';

/* Url to the Development API and access control for development
const hostname = window && window.location && window.location.hostname;
let baseUrl = "https://localhost:8443/api/";
let accessControl = "*";

if (hostname == 'web-stage.clear-cade.com') {
    // Url of the Staging API
    baseUrl = 'https://api-stage.clear-cade.com/api/';
    accessControl = "*";
} else if (hostname == 'clear-cade.com' || hostname == 'prod.clear-cade.com') {
    // Url of the Production API (published and unpublished one)
    baseUrl = 'https://api-prod.clear-cade.com/api/';
    accessControl = "*";
}
*/

const api = axios.create({
    baseURL: baseUrl,
    timeout: 8000,
    headers: {
        'Access-Control-Allow-Origin': accessControl
    }
})

export const apiErrorHandler = (error) => {
    if (isNullOrEmpty(error)) {
        return "Unknown error";
    }

    if (isNullOrEmpty(error.response)) {
        return error.message;
    }

    if (!isNullOrEmpty(error.response.data)) {
        if (!isNullOrEmpty(error.response.data.messageActionType)) {
            return error.response.data.messageActionType;
        }
        else if (!isNullOrEmpty(error.response.data.message)) {
            return error.response.data.message
        }
    }

    if (error.response.status == 401) {
        return "Session Timeout.  Your CADE session has timed out due to inactivity.  You have NOT lost any work.  Please login to CADE again to resume your activities.";
    }
    else {
        return "CADE API returned error with status: " + error.response.status;
    }
}

export const apiResponseHandler = (response) => {
    if (isNullOrEmpty(response)) {
        return "Unknown response";
    }

    if (isNullOrEmpty(response.data) || isNullOrEmpty(response.data.message)) {
        return response.status;
    }

    return response.data.message;
}

export default api;


// WEBPACK FOOTER //
// ./src/services/AxiosService.js